<ng-container *ngIf="!!params">
    <tt-button-goto
        *ngIf="params.show_button_custactportalusers === '1'"
        ttText="participants"
        [ttBadge]="params.nbr_of_participants"
        ttGoto="custactmembers"
        [ttGotoParms]="{ custact_no: params.custact_no }"
    ></tt-button-goto>
    <tt-button-goto
        ttText="workdetails_custact_customer"
        [ttBadge]="params.nbr_of_custact_customer"
        ttGoto="custactcustomers"
        [ttGotoParms]="{ argtype: 'custact_no', argvalue: params.custact_no }"
    ></tt-button-goto>
    <tt-button-goto *ngIf="params.show_button_jobcalc === '1'" ttText="custact_calc" ttGoto="custactcalc" [ttGotoParms]="{ argtype: 'custact', argvalue: params.custact_no }"></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_button_custactplanning === '1'"
        ttText="activityplanning"
        ttGoto="custactplanning"
        [ttGotoParms]="{ argtype: 'custact_no', argvalue: params.custact_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_button_subtasks === '1'"
        ttText="subtasks"
        [ttBadge]="params.nbr_of_childs"
        ttGoto="subtasks"
        [ttGotoParms]="{ custact_no: params.custact_no, retrievetype: 'child', include_top: '0' }"
    ></tt-button-goto>
    <tt-button-goto *ngIf="params.show_button_gantt === '1'" ttText="custact_gantt" ttGoto="custactgantt" [ttGotoParms]="{ connectto: 'custact', connectto_value: params.custact_no }"></tt-button-goto>
    <tt-button-goto *ngIf="params.show_button_categoridatas === '1'" ttText="categorydata" ttGoto="categorydatas" [ttGotoParms]="{ argtype: 'custact', argvalue: params.custact_no }"></tt-button-goto>
    <tt-button-goto
        *ngIf="params.sum_salaryhours !== '0'"
        ttText="registered_previous"
        [ttBadge]="params.sum_salaryhours"
        ttGoto="powtimegroup"
        [ttGotoParms]="{
            cust_no: 0,
            project_keyno: 0,
            projectprosess_keyno: 0,
            custact_no: params.custact_no,
            date_start: params.min_date_start,
            date_end: params.max_date_end,
            grouptype: 'M',
            equipment_id: '-',
            labour_no: 0,
            prod_id: '-',
        }"
    ></tt-button-goto>
</ng-container>
